// utils/originWarehouse.ts — PURE: pilih gudang asal (origin ongkir) dari daftar live.
//
// SATU SUMBER untuk halaman publik (FormViewer) + popup tarif Edit Pesanan.
// Aturan user 2026-10-27: ongkir WAJIB fresh dari GUDANG LIVE, snapshot
// `forms.everproSettings` hanya fallback saat daftar gudang gagal dimuat —
// snapshot lama bisa beda kode pos → tarif beda (insiden #20b259f7:
// 40559 → Rp34.722 vs snapshot 46311 → Rp40.274 untuk rute yang sama).

export type PublicWarehouse = { id?: string; postalCode?: string; subDistrict?: string; isDefault?: boolean };

// Urutan: warehouseId eksplisit → isDefault → pertama yang punya kode pos.
// Entri tanpa kode pos DIABAIKAN (origin kosong = ongkir mustahil dihitung).
export function pickOriginWarehouse(list: unknown, warehouseId?: string): PublicWarehouse | null {
    const all = (Array.isArray(list) ? list : []).filter((w): w is PublicWarehouse => !!w && typeof w === 'object');
    const usable = all.filter((w) => String(w.postalCode || '').trim() !== '');
    if (!usable.length) return null;
    if (warehouseId) {
        const match = usable.find((w) => w.id === warehouseId);
        if (match) return match;
    }
    return usable.find((w) => w.isDefault) || usable[0];
}

export interface RateOrigin {
    originPostalCode: string;
    originSubDistrictName: string;
    source: 'warehouse' | 'snapshot' | 'none';
}

// Resolusi origin untuk penarikan tarif: gudang LIVE menang; snapshot hanya
// dipakai bila daftar gudang kosong/gagal (source='snapshot' → caller WAJIB
// memberi peringatan karena tarif bisa beda dari gudang sebenarnya).
export function resolveRateOrigin(args: {
    warehouses: unknown;
    warehouseId?: string;
    snapshotOrigin?: string | null;
    snapshotSubDistrict?: string | null;
}): RateOrigin {
    const wh = pickOriginWarehouse(args.warehouses, args.warehouseId);
    if (wh?.postalCode) {
        return {
            originPostalCode: String(wh.postalCode).trim(),
            originSubDistrictName: String(wh.subDistrict || args.snapshotSubDistrict || '').trim(),
            source: 'warehouse',
        };
    }
    const snap = String(args.snapshotOrigin || '').trim();
    if (snap) {
        return { originPostalCode: snap, originSubDistrictName: String(args.snapshotSubDistrict || '').trim(), source: 'snapshot' };
    }
    return { originPostalCode: '', originSubDistrictName: '', source: 'none' };
}
